import { useTags } from "sdk/command-palette/queries"

export const PAGE_ID = "tag-search"

export const SHORTCUT = "f t"

const SEARCH_ENTRY_COMMAND = {
  id: "search-tags",
  label: "Search Tags…",
  icon: "search",
  group: "Search",
  keywords: ["find", "tag", "label"],
  shortcut: SHORTCUT,
  onSelect: api => api.pushPage(PAGE_ID)
}

/**
 * Provider for tag search. At the root it offers the "Search tags…" entry that
 * opens the subpage. Unlike subscriber search, the whole tag list is small and
 * changes rarely, so we preload it once when the subpage opens and let cmdk
 * filter it client-side (the subpage sets `shouldFilter: true`). Selecting a tag
 * navigates to the subscribers list filtered by that tag.
 *
 * @type {import("../types").Provider}
 */
export function useTagSearchProvider({ activePageId }) {
  const active = activePageId === PAGE_ID

  const { data, isFetching } = useTags({ enabled: active })

  if (!activePageId) {
    return { commands: [SEARCH_ENTRY_COMMAND], isLoading: false }
  }

  if (!active) return { commands: [], isLoading: false }

  const commands = (data?.tags ?? []).map(tag => ({
    id: `tag-${tag.id}`,
    label: tag.name,
    icon: "tag",
    group: "Tags",
    onSelect: api =>
      api.navigate(
        `/subscribers?subscribable_type=Tag&subscribable_ids=${tag.id}`
      )
  }))

  return { commands, isLoading: isFetching }
}

/**
 * @returns {import("../types").Shortcut[]}
 */
export function getTagSearchShortcuts() {
  return [{ shortcut: SHORTCUT, onTrigger: api => api.pushPage(PAGE_ID) }]
}
